module.exports = __webpack_public_path__ + "static/media/men.7f41b588.webp";